import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "../styles/propertyShowcase.css";

import PropertyShowcaseCarousel from "./PropertyShowcase/PropertyShowcaseCarousel";
import PropertyShowcaseCard from "./PropertyShowcase/PropertyShowcaseCard";

import { useFavorites } from "./Context/FavoritesContext";
import { db } from "../firebaseConfig";
import { ref, onValue } from "firebase/database";

import { Snackbar, Alert } from "@mui/material";

const InvestirMorar = () => {
  const navigate = useNavigate();

  const { favorites, addFavorite, removeFavorite } = useFavorites();
  const [imoveis, setImoveis] = useState([]);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchImoveis = () => {
      const imoveisRef = ref(db, "imoveisPublicos/");
      onValue(imoveisRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const imoveisArray = Object.entries(data)
            .map(([id, imovel]) => ({
              id,
              ...imovel,
            }))
            .filter(
              (item) =>
                item.imovelInfo?.construtora === "false" &&
                item.imovelInfo?.status === true
            )
            .reverse()
            .slice(0, 20);
          setImoveis(imoveisArray);
        } else {
          setImoveis([]);
        }
      });
    };

    fetchImoveis();
  }, []);

  const toggleFavorite = (property) => {
    if (
      favorites.some(
        (fav) => fav.imovelInfo.codigo === property.imovelInfo.codigo
      )
    ) {
      removeFavorite(property.imovelInfo.codigo);
      setToastMessage("Removido dos favoritos!");
    } else {
      addFavorite(property);
      setToastMessage("Adicionado aos favoritos!");
    }
    setToastOpen(true);
  };

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const handleNavigate = (codigo) => {
    navigate(`/imovel/${codigo}`);
  };

  return (
    <>
      <PropertyShowcaseCarousel
        eyebrow="Dos nossos clientes"
        title="Escolha um lugar para morar ou investir"
        items={imoveis}
        getItemKey={(property) => property.id}
        emptyLabel="Carregando imóveis..."
        variant="muted"
        renderItem={(property) => (
          <PropertyShowcaseCard
            property={property}
            isFavorite={favorites.some(
              (fav) => fav.imovelInfo.codigo === property.imovelInfo.codigo
            )}
            onToggleFavorite={toggleFavorite}
            onNavigate={handleNavigate}
          />
        )}
        footer={
          <div className="showcase-section__footer">
            <button
              type="button"
              className="showcase-section__footer-link"
              onClick={() => navigate("/todos-imoveis")}
            >
              Ver todos os imóveis <FaArrowRight aria-hidden="true" />
            </button>
          </div>
        }
      />

      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToast}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "var(--verde)",
            color: "var(--brancoUm)",
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default InvestirMorar;
